import { Lookup } from './lookup.interface';
import { ProgramList } from './program-list';
// const diaName = ProgramList.dia;
const aishName = ProgramList.aish;
const adpName = ProgramList.adap;

export const AishBenefitsReceived: { [name: string]: Lookup } = {
  yes_transition: {
    code: 'yes_transition',
    displayValue: `Yes - My file was transitioned to ${adpName.abbreviation} <<adapDate>>`,
    transformLookup: 'receivedBenefits_yes_transition', //name of the transform label key
  },

  yes_stopped: {
    code: 'yes_stopped',
    displayValue: `Yes - I was receiving ${aishName.abbreviation} or ${adpName.abbreviation} within the last 24 months but stopped`,
    transformLookup: 'receivedBenefits_yes_stopped',
  },
  no: {
    code: 'no',
    displayValue: 'No',
    transformLookup: 'receivedBenefits_no',
  },
};

export const AishBenefitsReceivedOnBehalf: { [name: string]: Lookup } = {
  yes_transition: {
    code: 'yes_transition',
    displayValue: `Yes - their file was transitioned to ${adpName.abbreviation} <<adapDate>>`,
  },

  yes_stopped: {
    code: 'yes_stopped',
    displayValue: `Yes - they were receiving ${aishName.abbreviation} or ${adpName.abbreviation} within the last 24 months but stopped`,
  },

  no: {
    code: 'no',
    displayValue: 'No',
  },
};
